"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _selectors = require("./selectors");

var _getInputProps2 = _interopRequireDefault(require("./getInputProps"));

var _actions = require("../actions");

function applyMapDispatchToProps(mapDispatchToProps, dispatch, ownProps) {
  if (typeof mapDispatchToProps === 'function') {
    return mapDispatchToProps(dispatch, ownProps);
  } else {
    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
  }
}
/**
 * Creates a function that works like react-redux `connect`, but adds a prop: *`inputProps`*
 * which contains the props for each input specified in the inputConfig.
 * This is generated with redux-inputs's `getInputProps` function.
 *
 * @param inputConfig {Object}
 * @param options
 *      options.inputPropsKey {String}
 *      options.inputActionsKey {String}
 * @returns `connect` function
 */


var _default = function _default(inputConfig, mapReduxInputsToProps) {
  var connect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _reactRedux.connect;

  var mapReduxInputsFn = mapReduxInputsToProps || function (reduxInputs) {
    return {
      reduxInputs: reduxInputs
    };
  };

  var inputActions = (0, _actions.bindActions)(inputConfig);
  return function (mapStateToProps) {
    var mapDispatchToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (dispatch) {
      return {
        dispatch: dispatch
      };
    };
    var mergeProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (stateProps, dispatchProps, ownProps) {
      return (0, _objectSpread2.default)({}, stateProps, dispatchProps, ownProps);
    };
    var connectOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return function (Component) {
      return connect(function (state, ownProps) {
        return (0, _objectSpread2.default)({
          _reduxInputsState: (0, _selectors.inputsSelector)(inputConfig)(state),
          // Temporary prop to pass down to merge
          _reduxInputsForm: (0, _selectors.formSelector)(inputConfig)(state)
        }, mapStateToProps && mapStateToProps(state, ownProps));
      }, function (dispatch, ownProps) {
        return (0, _objectSpread2.default)({
          _getInputProps: function _getInputProps(inputs) {
            return (0, _getInputProps2.default)(inputConfig, inputs, dispatch);
          },
          // Temporary
          _reduxInputsActions: (0, _redux.bindActionCreators)(inputActions, dispatch)
        }, mapDispatchToProps && applyMapDispatchToProps(mapDispatchToProps, dispatch, ownProps));
      }, function (_ref2, // stateProps
      _ref, // dispatchProps
      ownProps) {
        var _reduxInputsState = _ref2._reduxInputsState,
            _reduxInputsForm = _ref2._reduxInputsForm,
            stateProps = (0, _objectWithoutProperties2.default)(_ref2, ["_reduxInputsState", "_reduxInputsForm"]);
        var _getInputProps = _ref._getInputProps,
            _reduxInputsActions = _ref._reduxInputsActions,
            dispatchProps = (0, _objectWithoutProperties2.default)(_ref, ["_getInputProps", "_reduxInputsActions"]);
        return (0, _objectSpread2.default)({}, mapReduxInputsFn((0, _objectSpread2.default)({}, _reduxInputsForm, _reduxInputsActions, {
          // setInputs, updateAndValidate, validateInputs, resetInputs, initializeInputs
          inputProps: _getInputProps(_reduxInputsState) // Use temporary props to create inputProps

        })), mergeProps(stateProps, dispatchProps, ownProps));
      }, connectOptions)(Component);
    };
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/lib/util/connectWithInputs.js
// module id = 437
// module chunks = 0